import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { CalculationMethod } from '@skylab-shared/dataModel';

export type PurchaseKindItem = Omit<PurchaseKindInternalItem, 'version' | 'defaultNumberingId'>;

type PurchaseKindInternalItem = {
    readonly defaultNumberingId: number;
    readonly version: string;

    readonly adjustment: boolean;
    readonly defaultCalculationMethod: CalculationMethod;
    readonly defaultDueDate: number;
    readonly defaultPaymentMethodId: number;
    readonly name: string;
};

export class PurchaseKindQuery extends Query<PurchaseKindItem[]> { }

export class PurchaseKindQueryHandlerBase implements QueryHandler<PurchaseKindQuery, PurchaseKindItem[]> {
    private static Url = TaggedUrl.join('purchase/kinds', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: PurchaseKindQuery): Promise<PurchaseKindItem[]> {
        const { data } = await this.http.get<{ items: PurchaseKindInternalItem[]; }>(PurchaseKindQueryHandlerBase.Url);
        return data.items.map(i => ({
            name: i.name,
            adjustment: i.adjustment,
            defaultCalculationMethod: i.defaultCalculationMethod,
            defaultDueDate: i.defaultDueDate,
            defaultPaymentMethodId: i.defaultPaymentMethodId
        }));
    }
}
